<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <page-title :routeProps="routeProps"></page-title>
          <div class="vertical-center-container text-xs-right">
            <v-tooltip left v-if="$store.state.user.userAuthClass.allocationStagingRead">
              <v-btn
                slot="activator"
                :color="$store.state.global.pages.allocation.color"
                flat
                router
                :icon="!$vuetify.breakpoint.smAndUp"
                :to="{name: 'allocationStaging'}"
              >
                <v-icon
                  :left="$vuetify.breakpoint.smAndUp"
                >{{$store.state.global.pages.allocationStaging.icon}}</v-icon>
                {{$vuetify.breakpoint.smAndUp ? 'Batch Staging...' : ''}}
              </v-btn>Batch Allocation Staging
            </v-tooltip>
            <v-tooltip left v-if="userAuthClass">
              <v-btn
                slot="activator"
                icon
                large
                flat
                :color="$store.state.global.pages.allocation.color"
                @click="importDialog = true"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>Import Allocations
            </v-tooltip>
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 lg3>
            <v-autocomplete
              label="Choose filter"
              :items="filterCols"
              v-model="filterCol"
              prepend-icon="list"
              :clearable="true"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <date-picker-wrapper
              v-model="filterDate"
              label="Date"
              :color="$store.state.global.pages.allocation.color"
              :rules="[]"
            ></date-picker-wrapper>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div>
            <chip-display></chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>
      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="$store.state.global.pages.allocation.color"
        class="overlap-fab"
        @click="addBatchDialog = !addBatchDialog"
        v-if="$store.state.user.userAuthClass.allocationStagingEntry"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>

    <v-dialog v-model="addAllocationDialog" lazy max-width="700px" v-if="userAuthClass">
      <add-allocation @close="addAllocationDialog = false"></add-allocation>
    </v-dialog>

    <v-dialog v-model="importDialog" lazy max-width="700px" v-if="userAuthClass">
      <import-allocations @close="importDialog = false" title="Import Allocations"></import-allocations>
    </v-dialog>
    <!-- <docket-add-wrapper v-model="addDocketDialog"></docket-add-wrapper> -->
    <filter-drawer></filter-drawer>
    <batch-add-wrapper v-model="addBatchDialog"></batch-add-wrapper>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import RouteProps from "@/services/mixins/routeProps";

import { addDays } from "date-fns";
import FormatDates from "@/services/mixins/formatDates";

import AddAllocation from "@/components/allocations/addAllocation";
import ImportAllocations from "@/components/trips/actions/importDockets";
import FilterDrawer from "@/components/trips/filterDrawer";
import DatePickerWrapper from "@/components/ui/datePickerWrapper";

import BatchAddWrapper from "@/modules/batchAllocations/wrapper";

import ChipDisplay from "@/components/ui/chipDisplay";
export default {
  mixins: [RouteProps, FormatDates],
  data() {
    return {
      addBatchDialog: false,
      filterCols: [
        {
          value: "site.name",
          text: "Site"
        },
        {
          value: "vehicle.contractor.name",
          text: "Sub-contractor"
        },
        {
          value: "driver.name",
          text: "Driver"
        },
        {
          value: "vehicle.name",
          text: "Vehicle"
        },
        {
          value: "vehicleType.name",
          text: "Vehicle Type"
        },
        {
          value: "tip.name",
          text: "Tip"
        },
        {
          value: "spoil.name",
          text: "Spoil"
        }
      ],
      importDialog: false,
      addAllocationDialog: false
    };
  },
  components: {
    AddAllocation,
    ImportAllocations,
    FilterDrawer,
    DatePickerWrapper,
    BatchAddWrapper,
    ChipDisplay
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    }
  },
  computed: {
    filterCol: Store.getSet({ store: "allocations", prop: "filterCol" }),
    filterBy: Store.getSet({ store: "allocations", prop: "filterBy" }),
    filterDate: Store.getSet({ store: "allocations", prop: "filterDate" }),
    drawer: Store.getSet({ store: "shared", prop: "drawer" })
  },
  mounted() {
    this.filterCol = null;
  }
};
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
